import { InjectableApi } from '../../../../shared/decorators';
import { ApiResponse } from '../../../../entities/types';
import { Observable } from 'rxjs';
import {
  CompileBtbApiResponse,
  DraftPackApiResponse,
  PackApiResponse,
  CreatePackApiResponse,
  UpdatePackPayload,
} from '../types/template.type';
import { ApiService } from '../../../../shared/services';
import {
  LinkDetails,
  PackPayload,
  SharedActiveLink,
} from '../../../../shared/types';

@InjectableApi({
  baseSegment: 'ats/pack',
})
export class PackService extends ApiService {
  createPack(
    payload: FormData,
  ): Observable<ApiResponse<CreatePackApiResponse>> {
    return this.post('', payload);
  }

  getPacks(query: string): Observable<ApiResponse<PackApiResponse[]>> {
    return this.get(`${query}`);
  }

  getPackDetail(
    id: string,
    query: string,
  ): Observable<ApiResponse<CompileBtbApiResponse>> {
    return this.get(`/${id}${query}`);
  }

  getDraftPacks(query: string): Observable<ApiResponse<DraftPackApiResponse>> {
    return this.get(`/draft${query}`);
  }

  clonePack(payload: { id: string }) {
    return this.post('/clone', payload);
  }

  getDraftedPackUrl(
    id: string,
  ): Observable<
    ApiResponse<{ mainFile: string; smallPreview: string; mainPreview: string }>
  > {
    return this.get(`/${id}/url`);
  }

  getSharedLinks(
    id: string,
    query: string,
  ): Observable<ApiResponse<SharedActiveLink[]>> {
    return this.get(`/${id}/links${query}`);
  }

  revokeSharedLink(id: string) {
    return this.patch(`/share/${id}/revoke`, '');
  }

  generatePackLink(payload: PackPayload) {
    return this.post(`/share`, payload);
  }

  getPackDetailsByToken(token: string): Observable<ApiResponse<LinkDetails>> {
    return this.get(`/share/${token}`);
  }

  downloadSharedPack(id: string): Observable<
    ApiResponse<{
      signedUrls: {
        mainFile: string;
        smallPreview: string;
        mainPreview: string;
      };
    }>
  > {
    return this.get(`/share/${id}/download`);
  }

  sendInvite(id: string, payload: { emails: string[] }) {
    return this.post(`/share/${id}/invite`, payload);
  }

  compilePack(id: string, payload: FormData) {
    return this.post(`/${id}/compile`, payload);
  }

  updatePack(id: string, payload: UpdatePackPayload) {
    return this.patch(`/${id}`, payload);
  }
}
